import { PATHS } from '@/constants/page-paths';

// Only Home and Chat History for desktop navigation
export const desktopNavItems = [
  { path: PATHS.HOME, title: 'Home' },
  { path: PATHS.CHAT_HISTORY, title: 'Chat History' },
];

// All items for mobile navigation
export const mobileNavItems = [
  { path: PATHS.HOME, title: 'Home' },
  { path: PATHS.PROFILE, title: 'Profile' },
  { path: PATHS.BUY_POINTS, title: 'Buy Points' },
  { path: PATHS.CHAT_HISTORY, title: 'Chat History' },
];
